import type { ISortDirection } from '@app/lib/sorting'
import type { AppAction } from '@app/state'

export interface State {
  birthSexFilter?: string[]
  dateOfBirthFilter?: string
  mrnInputFilter?: string
  nameInputFilter?: string
  pageNumber: number
  recordsPerPage: number
  sortField?: string
  sortDirection?: ISortDirection
}

export const initialState: State = {
  birthSexFilter: [],
  mrnInputFilter: null,
  nameInputFilter: null,
  pageNumber: 1,
  recordsPerPage: 50,
}

export enum ActionType {
  SetBirthSex = 'PATIENT_LIST/SET_BIRTH_SEX',
  SetDateOfBirth = 'PATIENT_LIST/SET_DATE_OF_BIRTH',
  SetMrnInputFilter = 'PATIENT_LIST/SET_MRN_INPUT_FILTER',
  SetNameInputFilter = 'PATIENT_LIST/SET_NAME_INPUT_FILTER',
  SetPageNumber = 'PATIENT_LIST/SET_PAGE_NUMBER',
  SetPatientListState = 'PATIENT_LIST/SET_STATE',
  SetRecordsPerPage = 'PATIENT_LIST/SET_RECORDS_PER_PAGE',
  SetSort = 'PATIENT_LIST/SET_SORT',
  ResetFilters = 'PATIENT_LIST/RESET_FILTERS',
}

export type Action =
  | { type: ActionType.SetBirthSex; value?: string[] }
  | { type: ActionType.SetDateOfBirth; value?: string }
  | { type: ActionType.SetMrnInputFilter; value?: string }
  | { type: ActionType.SetNameInputFilter; value?: string }
  | { type: ActionType.SetPageNumber; value: number }
  | { type: ActionType.SetPatientListState; state: State }
  | { type: ActionType.SetRecordsPerPage; value: number }
  | { type: ActionType.SetSort; field?: string; direction?: ISortDirection }
  | { type: ActionType.ResetFilters }

export const actions = {
  setBirthSex(value?: string[]) {
    return { type: ActionType.SetBirthSex, value }
  },
  setDateOfBirthFilter(value?: string) {
    return { type: ActionType.SetDateOfBirth, value }
  },
  setMrnInputFilter(value?: string) {
    return { type: ActionType.SetMrnInputFilter, value }
  },
  setNameInputFilter(value?: string) {
    return { type: ActionType.SetNameInputFilter, value }
  },
  setPageNumber(value: number) {
    return { type: ActionType.SetPageNumber, value }
  },
  setPatientListState(state: State) {
    return { type: ActionType.SetPatientListState, state }
  },
  setRecordsPerPage(value: number) {
    return { type: ActionType.SetRecordsPerPage, value }
  },
  setSort(field?: string, direction?: string) {
    return { type: ActionType.SetSort, field, direction }
  },
  resetFilters() {
    return { type: ActionType.ResetFilters }
  },
}

export function reducer(state: State = initialState, action: AppAction): State {
  switch (action.type) {
    case ActionType.SetBirthSex:
      return {
        ...state,
        birthSexFilter: action.value,
      }

    case ActionType.SetDateOfBirth:
      return {
        ...state,
        dateOfBirthFilter: action.value,
      }

    case ActionType.SetMrnInputFilter:
      return {
        ...state,
        mrnInputFilter: action.value,
      }

    case ActionType.SetNameInputFilter:
      return {
        ...state,
        nameInputFilter: action.value,
      }
    case ActionType.SetPageNumber:
      return {
        ...state,
        pageNumber: action.value,
      }

    case ActionType.SetPatientListState:
      return action.state

    case ActionType.SetRecordsPerPage:
      return {
        ...state,
        recordsPerPage: action.value,
      }
    case ActionType.SetSort:
      return {
        ...state,
        sortField: action.field,
        sortDirection: action.direction,
      }
    case ActionType.ResetFilters:
      return { ...initialState }
    default:
      return state
  }
}
